import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, Facebook } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/site";

export const AnnouncementBar = () => (
    <div className="bg-[#FFD400] border-b-2 border-[#111111] overflow-hidden" data-testid="announcement-bar">
        <div className="flex animate-marquee whitespace-nowrap py-2.5">
            {["a", "b", "c"].map((k) => (
                <div key={`marquee-loop-${k}`} className="flex items-center gap-6 pr-6">
                    <span className="font-['Anton'] tracking-wide text-base sm:text-lg uppercase text-[#111111] flex items-center gap-3">
                        <span className="text-[#E11D2A]">★</span>
                        Now servicing Vancouver, Battle Ground Washington &amp; surrounding areas!
                        <span className="text-[#E11D2A]">★</span>
                    </span>
                </div>
            ))}
        </div>
    </div>
);

export const Header = () => {
    const [open, setOpen] = useState(false);
    const links = [
        { href: "/#services", label: "Services" },
        { href: "/drywall-paint", label: "Drywall & Paint", isRoute: true },
        { href: "/solar-tubes", label: "Solar Tubes", isRoute: true },
        { href: "/fans", label: "Fans", isRoute: true },
        { href: "/decks", label: "Decks", isRoute: true },
        { href: "/bathroom-remodel", label: "Bath Remodel", isRoute: true },
        { href: "/media-walls", label: "Media Walls", isRoute: true },
        { href: "/roof-demossing", label: "Roof Moss", isRoute: true },
        { href: "/managers", label: "For Pros", isRoute: true },
        { href: "/faq", label: "FAQ", isRoute: true },
        { href: "/#contact", label: "Contact" },
    ];
    return (
        <header className="sticky top-0 z-50 bg-[#F6F5F2] border-b border-[#E2DFD8]" data-testid="site-header">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
                    <img src="https://customer-assets.emergentagent.com/job_service-connect-473/artifacts/psc7s3p2_10165.jpg" alt="5 Star Construction Services LLC logo" className="w-12 h-12 object-contain mix-blend-multiply" />
                    <div className="leading-tight">
                        <div className="font-display font-extrabold tracking-tight text-[#111812] text-base">5 Star Construction Services LLC</div>
                        <div className="text-[11px] tracking-[0.18em] uppercase text-[#5F5F5F]">General Contractor · CCB #232477</div>
                    </div>
                </Link>
                <nav className="hidden md:flex items-center gap-7">
                    {links.map((l) =>
                        l.isRoute ? (
                            <Link key={l.href} to={l.href} className="font-['Manrope'] text-sm font-semibold text-[#111812] hover:text-[#E11D2A] transition-colors" data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                                {l.label}
                            </Link>
                        ) : (
                            <a key={l.href} href={l.href} className="font-['Manrope'] text-sm font-semibold text-[#111812] hover:text-[#E11D2A] transition-colors" data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                                {l.label}
                            </a>
                        ),
                    )}
                    <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" data-testid="nav-facebook" className="w-11 h-11 border border-[#111111] hover:bg-[#111111] hover:text-white transition-colors flex items-center justify-center" aria-label="Facebook">
                        <Facebook className="w-5 h-5" strokeWidth={2.25} />
                    </a>
                    <a href={SITE.phoneHref} data-testid="nav-call-now">
                        <Button className="rounded-none h-11 px-5 bg-[#E11D2A] hover:bg-[#B0121E] text-white font-bold tracking-wide font-['Manrope']">
                            <Phone className="w-4 h-4 mr-2" strokeWidth={2.5} />
                            CALL NOW
                        </Button>
                    </a>
                </nav>
                <button onClick={() => setOpen((v) => !v)} className="md:hidden w-11 h-11 border border-[#111111] flex items-center justify-center" aria-label="menu" data-testid="mobile-menu-toggle">
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>
            </div>
            {open && (
                <div className="md:hidden border-t border-[#E2DFD8] bg-[#F6F5F2]" data-testid="mobile-menu">
                    <div className="px-6 py-4 flex flex-col gap-4">
                        {links.map((l) =>
                            l.isRoute ? (
                                <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="font-['Manrope'] text-base font-semibold text-[#111812]" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                                    {l.label}
                                </Link>
                            ) : (
                                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="font-['Manrope'] text-base font-semibold text-[#111812]" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                                    {l.label}
                                </a>
                            ),
                        )}
                        <a href={SITE.phoneHref} data-testid="mobile-call-now">
                            <Button className="rounded-none w-full h-12 bg-[#E11D2A] hover:bg-[#B0121E] text-white font-bold">
                                <Phone className="w-4 h-4 mr-2" /> CALL {SITE.phoneDisplay}
                            </Button>
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export const Footer = () => (
    <footer className="bg-[#111111] text-[#F6F5F2]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20">
            <div className="grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-6">
                    <img src="https://customer-assets.emergentagent.com/job_service-connect-473/artifacts/gnnpmcvz_10166.jpg" alt="5 Star Construction Services LLC — General Contractor CCB #232477" className="w-full max-w-md bg-white border-2 border-[#F6F5F2]/15" />
                    <p className="mt-6 font-['Manrope'] text-base text-[#F6F5F2]/70 max-w-md">
                        Family-run handyman &amp; general construction services based in Medford, Oregon. {SITE.license}.
                    </p>
                </div>
                <div className="lg:col-span-3">
                    <div className="font-['Manrope'] text-xs uppercase tracking-[0.22em] font-bold text-[#E11D2A]">Service Area</div>
                    <ul className="mt-4 grid grid-cols-2 gap-y-2">
                        {SITE.serviceArea.map((c) => (
                            <li key={c} className="font-['Manrope'] text-sm text-[#F6F5F2]/85">{c}</li>
                        ))}
                    </ul>
                </div>
                <div className="lg:col-span-3">
                    <div className="font-['Manrope'] text-xs uppercase tracking-[0.22em] font-bold text-[#E11D2A]">Reach us</div>
                    <ul className="mt-4 space-y-3">
                        <li><a href={SITE.phoneHref} className="font-display text-2xl font-bold hover:text-[#E11D2A]" data-testid="footer-phone">{SITE.phoneDisplay}</a></li>
                        <li className="font-['Manrope'] text-sm text-[#F6F5F2]/85">{SITE.emailDisplay}</li>
                        <li className="font-['Manrope'] text-sm text-[#F6F5F2]/85">Medford, OR · Southern Oregon</li>
                        <li className="pt-2">
                            <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-2 font-['Manrope'] text-sm font-bold text-[#F6F5F2] hover:text-[#E11D2A] transition-colors border-b border-[#F6F5F2]/30 hover:border-[#E11D2A] pb-1">
                                <Facebook className="w-4 h-4" strokeWidth={2.5} />
                                Follow us on Facebook
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mt-14 pt-6 border-t border-[#F6F5F2]/15 flex flex-col md:flex-row gap-3 justify-between items-start md:items-center">
                <div className="font-['Manrope'] text-xs text-[#F6F5F2]/60">
                    © {new Date().getFullYear()} 5 Star Construction Services LLC · All rights reserved.
                </div>
                <div className="flex flex-wrap gap-x-5 gap-y-2 items-center">
                    <a href="/privacy" className="font-['Manrope'] text-xs uppercase tracking-[0.18em] text-[#F6F5F2]/70 hover:text-[#F6F5F2]" data-testid="footer-privacy">Privacy</a>
                    <a href="/terms" className="font-['Manrope'] text-xs uppercase tracking-[0.18em] text-[#F6F5F2]/70 hover:text-[#F6F5F2]" data-testid="footer-terms">Terms</a>
                    <span className="font-['Manrope'] text-xs uppercase tracking-[0.2em] text-[#F6F5F2]/60">{SITE.license}</span>
                </div>
            </div>
        </div>
    </footer>
);
